import * as S from "./styles";

export function DatetimeLocal() {
  //create datetime São paulo, 13 de fevereiro de 2023
  const date = new Date();

  const dateNow = new Intl.DateTimeFormat("pt-BR", {
    dateStyle: "full",
  }).format(date);

  return (
    <>
      <S.HeaderDateTime>São Paulo, {dateNow}</S.HeaderDateTime>
    </>
  );
}
